import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../services/api';
import GamePageLayout from '../Layout/GamePageLayout';
import ConfettiDecoration from './components/ConfettiDecoration';
import SilhouetteGroup from './components/SilhouetteGroup';
import CreateGameButton from './components/CreateGameButton';
import JoinGameForm from './components/JoinGameForm';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleCreateGame = async () => {
    setLoading(true);
    setError(null);

    try {
      const { gameCode } = await apiService.createGame();
      navigate(`/game/${gameCode}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('home.failedToCreateGame'));
    } finally {
      setLoading(false);
    }
  };

  const handleJoinGame = async (gameCode: string) => {
    setError(null);
    navigate(`/game/${gameCode}`);
  };

  return (
    <GamePageLayout title={t('home.title')} isHeroTitle={true} error={error} showFooter={true}>
      <div className="w-full max-w-sm relative">
        <ConfettiDecoration />
        
        <div className="text-center relative z-20">
          <SilhouetteGroup />

          <div className="flex flex-col gap-6 items-center">
            <CreateGameButton onClick={handleCreateGame} loading={loading} />
            <JoinGameForm onJoinGame={handleJoinGame} />
          </div>
        </div>
      </div>
    </GamePageLayout>
  );
};

export default Home;